import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import PageLayout from '../../components/PageLayout.vue';
import JsonYaml from '../../components/JsonYaml.vue';
export default {
  __name: 'JsonYamlPage',
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(PageLayout, {
        title: "JSON与YAML转换",
        "current-page": "url"
      }, {
        default: _withCtx(() => [_createVNode(JsonYaml)]),
        _: 1
      });
    };
  }
};